import React from 'react';
import { useRouter } from 'next/navigation';
import Icon from '../Icon';

function BackButton({ iconName, onBack }) {
  const router = useRouter();

  return (
    <Icon
      type={iconName}
      color="#fff"
      className="rotate-90"
      onClick={() => (onBack !== undefined ? onBack() : router.back())}
    />
  );
}

export default BackButton;
